import React, { ErrorInfo } from 'react';

interface IRenderDefaultProps {
  error: Error;
}

const RenderDefault: React.FC<IRenderDefaultProps> = props => {
  const { error } = props;

  return (
    <div className="feelgood-error-boundary">
      <span className="feelgood-error-boundary-info">{error.toString()}</span>
    </div>
  );
};

export interface IFallbackComponentProps {
  error: Error;
  info: string;
}

export interface IErrorBoundaryProps {
  onError?: (err: Error, stack: string) => void;
  FallbackComponent?: React.ComponentType<IFallbackComponentProps>;
}

export interface IErrorBoundaryState {
  error: Error | null;
  info: string | null;
}

export default class ErrorBoundary extends React.Component<
  React.PropsWithChildren<IErrorBoundaryProps>,
  IErrorBoundaryState
> {
  public state: IErrorBoundaryState = {
    error: null,
    info: null,
  };

  public shouldComponentUpdate(): boolean {
    return true;
  }

  public componentDidCatch(error: Error, stack: ErrorInfo): void {
    const { onError } = this.props;
    const info = stack.componentStack || '';

    onError?.(error, info);

    this.setState({ error, info });
  }

  public render(): React.ReactNode {
    const { error, info } = this.state;
    const { children, FallbackComponent } = this.props;

    if (error !== null) {
      return FallbackComponent ? (
        <FallbackComponent error={error} info={info || ''} />
      ) : (
        <RenderDefault error={error} />
      );
    }

    return children;
  }
}
